import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = 'https://miamigardens2608.herokuapp.com/api'
const responseBody = res => res.body;

const requests = {
	get: url =>
		superagent.get(`${API_ROOT}${url}`).then(responseBody),
	post: (url, body) =>
		superagent.post(`${API_ROOT}${url}`,body).then(()=>{
		  window.location.reload();

		}),
	postFile: (url, body, destination, files) => {
		const req = superagent.post(`${API_ROOT}${url}`);
		for(var key in body){
			if(body[key]){
				req.field(key, body[key]);
			}
		}
		if(files){
			files.forEach((file) => {
				req.attach(destination, file, file.name)
			});
		}
		req.end((error, res) => {
		  window.location.reload();
		});
	    // superagent.post(`${API_ROOT}${url}`).attach(files[0], files[0].name).then(responseBody)
	},
	application: (url, data, files) => {
		const req = superagent.post(`${API_ROOT}${url}`);
		for(var key in files){
			if(files[key]){
				req.field(key, files[key]);
			}
		}

		for(var key in data){
			if(data[key]){
				for(var k in data[key]){
					if(data[key][k]){
						req.field(k, data[key][k])
					}
				}
			}
		}
		req.end((error, res) => {
		  window.location.reload();
		});
	}
};


const Groups = {
	all: page => requests.get('/groups'),
	// all: page => requests.get('/group'),
};

const Contact = {
	contact: (name, email, phone, message)  => {
		requests.post("/contact", {form:{name, email, phone, message}})
	}
};

const Application = {
	submit: (data, files)  => {
		requests.application("/application", data, files)
	}
};

const Maintenance ={
	image: (destination, files) => {
		requests.postFile("/maintenance/image?clientName=Miami%20Gardens%202608%20LLC.",
			destination, files)
	},
	upload: (name, email, phone, description, group, destination, address, files) => {
		requests.postFile("/maintenance/form"
			, {name, email, phone, description, group, destination, address},destination, files)
	}
};

export default {
	Groups,
	Maintenance,
	Contact,
	Application
};




// WEBPACK FOOTER //
// ./src/agent.js